function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M15.3 5.1c-6.6 0-12 5.4-12 12s5.4 12 12 12 12-5.4 12-12-5.5-12-12-12zm0 22.9c-6.1 0-11-4.9-11-11s4.9-10.9 11-10.9S26.2 11 26.2 17s-4.9 11-10.9 11zm6.2-17.2c.2.2.2.5 0 .7l-5.9 6c-.1.1-.2.2-.4.2-.1 0-.3 0-.4-.1-.2-.2-.2-.5 0-.7l5.9-6c.3-.3.6-.3.8-.1zM13.2 4V1.5c0-.3.2-.5.5-.5h3c.3 0 .5.2.5.5V4c0 .3-.2.5-.5.5s-.4-.2-.4-.5V2h-2v2c0 .3-.2.5-.5.5s-.6-.2-.6-.5zM4 10.2l-1-.9c-.1-.1-.2-.2-.2-.3 0-.1 0-.3.1-.4l1.3-1.7c.2-.2.6-.2.8-.1l1 .9c.2.2.3.5.1.7-.2.2-.5.3-.7.1L4.7 8l-.7.8.7.5c.2.2.3.5.1.7-.1.1-.3.2-.4.2-.2.1-.3 0-.4 0z"
})));